module.exports = "/images/icono-historial-white.svg?cad9daba97468dfbb135df6e82432226";